import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { AnchorButton, Button, Card, Heading, Stack, Text } from '@instabox/consumer-web-ui'
import Link from 'next/link'

import styles from './emptyList.module.scss'

export interface EmptyListProps {}

const EmptyList: FC<EmptyListProps> = () => {
  return (
    <Stack className={styles.container} justify="space-between" gap="lg">
      <Card variant="transparent">
        <Stack align="center">
          <Text italic fontWeight="bold">
            <FormattedMessage id="places.empty.content" />
          </Text>
          <Button>
            <FormattedMessage id="places.empty.reset" />
          </Button>
        </Stack>
      </Card>
      <Card variant="secondary">
        <Stack align="center">
          <Heading color="white" fontSize="sm">
            <FormattedMessage id="places.contact.title" />
          </Heading>
          <Text color="white" fontSize="sm">
            <FormattedMessage id="places.contact.title" />
          </Text>
          <Link href="/help" passHref legacyBehavior>
            <AnchorButton variant="solid">
              <FormattedMessage id="places.contact.button" />
            </AnchorButton>
          </Link>
        </Stack>
      </Card>
    </Stack>
  )
}

export default EmptyList
